import { API, GRAPHQL_AUTH_MODE } from '@aws-amplify/api';
import { onRegisterCompleted, onRegisterToWebinarCompleted } from './graphql/subscriptions';

// eslint-disable-next-line @typescript-eslint/ban-types
export function registerCompleteSubscription(registrationId: string, authToken: string): ReturnType<typeof API.graphql> {
  return API.graphql({
    authToken,
    variables: { registrationId },
    query: onRegisterCompleted,
    authMode: GRAPHQL_AUTH_MODE.AWS_LAMBDA
  });
}

// eslint-disable-next-line @typescript-eslint/ban-types
export function registerWebinarCompleteSubscription(registrationId: string, authToken: string): ReturnType<typeof API.graphql> {
  return API.graphql({
    authToken,
    variables: { registrationId },
    query: onRegisterToWebinarCompleted,
    authMode: GRAPHQL_AUTH_MODE.AWS_LAMBDA
  });
}

